<template>
  <div class="newsletter">
    <BootstrapTable
      id="table"
      :columns="columns"
      :data="rows"
      :options="options"
    />
  </div>
</template>

<script>
import services from '../../services/service.js'


export default {
  name: 'newsletter',
  data () {
    return {
      columns: [
        {
          title: '',
          field: 'numero',
          sortable: true,
          align: 'left'
        },
        {
          title: 'Codice Fiscale',
          field: 'codFisc',
          sortable: true,
          align: 'left'
        },
        {
          title: 'Materia iscrizione',
          field: 'materia',
          sortable: true
        },
        {
          title: 'Tribunale',
          field: 'tribunale',
          sortable: true
        },
        {
          title: 'Testo',
          field: 'testoRicerca',
          sortable: true
        }
      ],
      rows: [],
      options: {
        search: true,
        treeEnable: false,
        treeShowField: 'codFisc',
        idField: 'id',
        parentIdField: 'pid',
        rootParentId: 'root',
        onPostBody: function(data) {
          $('#table').treegrid();
          $('#table').treegrid('collapseAll');
        }
      }
    }
  },
  methods: {
    async getData() {
      let result = await services.execute('get', 'newsletter/admin');
      let avvocati = {};
      let data = result.map(x => {
        x.id = x.codFisc + x.materiaCodice + "-" + x.tribunaleCodice + "-" + x.testoRicerca;
        x.pid = x.codFisc;

        if(avvocati[x.codFisc] === undefined)
          avvocati[x.codFisc] = 0;
        avvocati[x.codFisc]++;

        return x;
      });
      
      let idx = 1;
      for(let avv of Object.keys(avvocati)){
        data.push({
          id: avv,
          codFisc: avv + " (" + avvocati[avv] + ")",
          pid: "root",
          numero: idx
        });
        idx += 1;
      }

      this.rows = data;
    }
  },
  async created() {
    await this.getData();

    this.$parent._data.loaded = true;
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Newsletter.vue